<template>
    <mySubPage>
        <div slot="header">
            <myNav>功能模板配置角色功能【{{role_cname}}】</myNav>
            <div class="sn-info-box">
                <el-row>
                    <el-col :span="12">
                        {{$t('mod_cname')}}{{$t('x_mh')}}<span class="f-blue">{{mod_cname}}</span>
                    </el-col>
                    <el-col :span="12">
                        {{$t('role_cname')}}{{$t('x_mh')}}<span class="f-blue">{{role_cname}}</span>
                    </el-col>
                </el-row>
            </div>
        </div>
        <el-form class="pd-10" ref="form" :model="formData" label-width="120px">
            <el-form-item :label="$t('select_func')">
                <el-tree class="tree-edit" ref="tree" :data="funcs" :default-checked-keys="select_funcs" node-key="func_id"
                         show-checkbox default-expand-all></el-tree>
            </el-form-item>
        </el-form>
        <div slot="footer">
            <div class="flex-box bg-f8">
                <div class="flex-box-bd"></div>
                <el-button style="margin-right: 8px" @click="cancel">{{$t('cancel')}}</el-button>
                <el-button type="primary" @click="submit">{{$t('save')}}</el-button>
            </div>
        </div>
    </mySubPage>
</template>

<script>
    export default {
        data:function(){
            return{
                formData: {
                    mod_id: '',
                    mod_role_id:'',
                    funcs :[],
                },
                mod_cname:'',
                role_cname: '',
                funcs: [],
                select_funcs: []
            }
        },
        mounted: function(){
            this.$parent.$parent.show_subview = true;
            var para = JSON.parse(this.$base.getRequest().data);
            this.formData.mod_id = para.mod_id;
            this.formData.mod_role_id = para.mod_role_id;
            this.mod_cname = para.mod_cname;
            this.role_cname = para.role_cname;
            this.getInfo();
        },
        methods:{
            cancel: function(){
                this.$base.linkBack();
            },
            getInfo: function(){
                const data = {
                    mod_id: this.formData.mod_id,
                    mod_role_id: this.formData.mod_role_id
                }
                this.$base.showLoading();
                this.$request.sendPost("mod/before-upd-role-func", data,(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.funcs = data.funcs;
                        this.select_funcs = data.select_funcs;
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            },
            submit: function(){
                this.formData.funcs = [];
                var check_data = this.$refs["tree"].getCheckedNodes();
                check_data.map(item => {
                    if(item.func_type && item.func_type == 'P'){
                        this.formData.funcs.push(item.func_id)
                    }
                });

                this.$base.showLoading();
                this.$request.sendPost("mod/upd-role-func",this.formData,(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.$base.msgSuccess(error.errmsg);
                        this.relist = true;
                        this.$base.linkBack();
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            }
        },
        beforeDestroy: function () {
            this.$parent.$parent.show_subview = false;
            this.$parent.$parent.relist = this.relist;
        }
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/system/mod_role_func.vue